<template>
  <el-container height="auto">
    
    <el-main>


        <el-form ref="form" :model="form"  :rules="rules" label-width="100px">
            <el-form-item label="姓名" prop="username">
              <el-col :span="12">
                  <el-input v-model="form.username"></el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="职称">
              <el-select v-model="form.title" placeholder="请选择职称">
                <el-option label="住院医师" value="住院医师"></el-option>
                <el-option label="主治医师" value="主治医师"></el-option>
                <el-option label="副主任医师" value="副主任医师"></el-option>
                <el-option label="主任医师" value="主任医师"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="省份/城市">
              <el-cascader :options="shenshidata" v-model="form.shenshi" clearable></el-cascader>
            </el-form-item>
            <el-form-item label="医院" prop="hospital">
              <el-col :span="12">
                <el-input v-model="form.hospital"></el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="科室" prop="department">
              <el-col :span="12">
                <el-input v-model="form.department"></el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="擅长领域" >
              <el-col :span="12">
                <el-input type="textarea" v-model="form.comments"></el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="常用邮箱" prop="email">
              <el-col :span="12">
                  <el-input v-model="form.email"></el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="手机号码" prop="phone">
              <el-col :span="12">
                  <el-input v-model="form.phone"></el-input>
              </el-col>
            </el-form-item>

            <el-form-item style="text-align:left">
              <el-button type="primary" @click="onSave">保存</el-button>
            </el-form-item>
            
          </el-form>

       
    </el-main>
  </el-container>
</template>
<script>
  export default {
    data() {
      var checkPhone = (rule, value, callback) => {
        const phoneReg = /^1[3|4|5|7|8][0-9]{9}$/
        if (!value) {
          //return callback(new Error('电话号码不能为空'))
          return callback()
        }
        setTimeout(() => {
          // Number.isInteger是es6验证数字是否为整数的方法,但是我实际用的时候输入的数字总是识别成字符串
          // 所以我就在前面加了一个+实现隐式转换

          if (!Number.isInteger(+value)) {
            callback(new Error('请输入数字值'))
          } else {
            if (phoneReg.test(value)) {
              callback()
            } else {
              callback(new Error('电话号码格式不正确'))
            }
          }
        }, 100)
      }
      var checkEmail = (rule, value, callback) => {
        
        const mailReg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/
        if (!value) {
          //return callback(new Error('邮箱不能为空'))
          return callback()
        }
        setTimeout(() => {
          if (mailReg.test(value)) {
            callback()
          } else {
            callback(new Error('请输入正确的邮箱格式'))
          }
        }, 100)
      }
      return {
        form: {
          name: '',
          description: '',
        },
        rules: {
          username: [
            { required: true, message: '请输入姓名', trigger: 'blur' },
          ],
          email:[
            { validator: checkEmail, trigger: 'blur' }
          ],
          phone:[
            { validator: checkPhone, trigger: 'blur' }
          ],
          hospital:[
            { required: true, message: '请输入医院', trigger: 'blur' },
          ],
          department:[
            { required: true, message: '请输入科室', trigger: 'blur' },
          ],
        },
        shenshidata:[]
      }
    },
    mounted(){
      this.getProfile();
      this.getRegionList();
    },
    methods: {
      getProfile(){
        this.$http.get('user/profile').then((res) => {
            this.form = res.data.info;

            let arryShenshi = [];
            arryShenshi.push(this.form.province);
            arryShenshi.push(this.form.city);
            this.form.shenshi = arryShenshi;
        });
      },
      getRegionList(){
        this.$http.get('region/list').then((res) => {
            this.shenshidata = res.data.list;
        });
      },
      onSave(){

        this.$refs["form"].validate(valid=>{
          if(valid){

            let postdata = {
              username:this.form.username,
              title:this.form.title || '',
              hospital:this.form.hospital || '',
              department:this.form.department || '',
              comments:this.form.comments || '',
              email:this.form.email || '',
              phone:this.form.phone || '',
              
            };

            if(this.form.shenshi || '' !='')
            {
              postdata.province = this.form.shenshi[0];
              postdata.city = this.form.shenshi[1];
            }
            else{
              postdata.province = '';
              postdata.city = '';
            }
            
            this.$http.post('user/edit', postdata).then((res) => {
                if(!res) return;

                //提醒成功
                this.$message({ type:'success', message:'个人资料已更新'})
                
            }); 

          }
        })

        
      },
      
    }
  }
</script>
<style scoped>

</style>